import React, {
  ForwardedRef, forwardRef,
} from 'react';
import '../../ScreenReportPdf/style.scss';
import ComponentLetterToPrint from './componentToPrint';

const getPageMargins = `
 @media print {
    @page {
      margin: 10px;
      size: letter landscape;
    }  
    .page-break {
      display: block;
      page-break-before: always;
    }
}
`;

function ReportPdf({ printRef }: { printRef: ForwardedRef<HTMLInputElement> }) {
  const pageMarginsCSS = getPageMargins;

  //   const { reportPdfResponse1 } = useSelector((state:RootState) => state.reportPdfSliceReducer);

  //   if (!reportPdfResponse1) {
  //     return null;
  //   }

  return (
    <>
      <style>{pageMarginsCSS}</style>
      <div style={{
        display: 'none', width: '900px', margin: '0 auto', backgroundColor: '#FFFFFF',
      }}
      >
        <ComponentLetterToPrint ref={printRef} />
      </div>
    </>
  );
}

const ScreenLetterPdf = forwardRef(ReportPdf);

export default ScreenLetterPdf;
